import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-laravel-dev',
  templateUrl: './hire-laravel-dev.component.html',
  styleUrls: ['./hire-laravel-dev.component.css']
})
export class HireLaravelDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-laravel-dev/hire-laravel-dev.component.ts